import { Card } from "@platform/ui/components";
import { heading } from "@platform/ui/styles";
import { Link, LinkProps } from "react-router";
import { twMerge } from "tailwind-merge";

export function AuthLayout({ children }: { children: React.ReactNode }) {
  return <main className="bg-ds-surface-1 grid min-h-screen w-full place-items-center px-4 sm:px-6">{children}</main>;
}

export function AuthCard({ children, className, ...rest }: React.ComponentPropsWithoutRef<"div">) {
  return (
    <Card {...rest} className={twMerge("w-full max-w-[400px] p-4 sm:p-6", className)}>
      {children}
    </Card>
  );
}

export function AuthLink({ children, className, ...rest }: LinkProps) {
  return (
    <Link {...rest} className={twMerge("text-ds-teal-10 text-sm no-underline hover:underline", className)}>
      {children}
    </Link>
  );
}

export function AuthHeading({ children, className, ...rest }: React.ComponentPropsWithoutRef<"h1">) {
  return (
    <h1 {...rest} className={twMerge(heading({ variant: "24", className: "sm:text-3xl" }), className)}>
      {children}
    </h1>
  );
}
